import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons'

import FiatCurrency   from './FiatCurrency'
import Currency       from './Currency'
import SandwichField  from 'src/components/SandwichField'
import MoneyField     from 'src/components/MoneyField'

const Amount = ({
  displayAmount, convertedAmount, handleAmountChange, toggleMode, i18n, errors,
  state, currencies, setFiatCurrency, accounts, top_accounts, setCryptoCurrency,
  blank_modal_src, widget_instance_token,
}) => {
  const error = errors?.fiat_amount?.[0] || errors?.crypto_amount?.[0]

  const currencyFormat = i18n.currency.format.replace('%c', '').trim()
  const currencyFormatParts = currencyFormat.split('%n')

  const formatAmountForCrypto = amount =>
    currencyFormat
    .replace('%u', amount.currency.symbol || '')
    .replace('%c', amount.currency.iso_code || '')
    .replace('%n', amount.amount.toString()).trim()

  const currencyCodeWithSwitcher = (amount, className) =>
    amount.isFiat ?
    <FiatCurrency
      className={className}
      state={state}
      currencies={currencies}
      setFiatCurrency={setFiatCurrency}
      blank_modal_src={blank_modal_src}
      widget_instance_token={widget_instance_token}
    >
      {amount.currency.iso_code}
    </FiatCurrency>
    :
    <span className={className}>{amount.currency.iso_code}</span>

  return (
    <div>
      <div className="mb-3">
        <Currency
          state={state}
          accounts={accounts}
          top_accounts={top_accounts}
          setCryptoCurrency={setCryptoCurrency}
          blank_modal_src={blank_modal_src}
          widget_instance_token={widget_instance_token}
        />
      </div>

      <div className="mb-3">
        <label className="visually-hidden" htmlFor="donation_amount">Amount</label>

        <div className="position-relative">
          <SandwichField
            type={MoneyField}
            className={`form-control form-control-lg text-end ${error ? 'is-invalid' : ''}`}
            style={{
              backgroundImage: 'none', // no validation image
              fontSize: '2.5rem',
              padding: '0.375rem 5rem 2rem 0.75rem',
              height: 'calc(1.5em + 2.375rem + 2px)',
            }}
            id="donation_amount"
            exponent={displayAmount.currency.exponent}
            value={displayAmount.amount.toString()}
            onChange={handleAmountChange}
            prefix={currencyFormatParts[0].replace('%u', displayAmount.currency.symbol || '')}
            suffix={currencyFormatParts[1].replace('%u', displayAmount.currency.symbol || '')}
            required
          />
          <p
            className="position-absolute border-top py-1 mb-0 text-end text-body-secondary"
            style={{ bottom: '1px', left: '1rem', right: '5rem' }}
          >~{formatAmountForCrypto(convertedAmount)}</p>
          <div
            className="position-absolute rounded-3 text-center py-1 d-flex flex-column align-items-start"
            style={{
              width: 'calc(4rem - 2px)',
              right: '1px',
              bottom: '1px',
              paddingRight: 'calc(0.75rem + 1px)',
              whiteSpace: 'nowrap',
            }}
          >
            {currencyCodeWithSwitcher(displayAmount, 'text-body')}
            <button
              type="button"
              className="btn btn-sm btn-outline-primary rounded-circle p-0 d-inline-flex align-items-center justify-content-center"
              style={{ height: '1.5rem', width: '1.5rem' }}
              onClick={toggleMode}
              aria-label="Switch fiat and crypto"
            >
              <FontAwesomeIcon icon={faExchangeAlt} style={{ transform: 'rotate(90deg)' }} />
            </button>
            {currencyCodeWithSwitcher(convertedAmount, 'text-body-secondary')}
          </div>
        </div>

        {
          error &&
          <div className="invalid-feedback d-block text-end">{error}</div>
        }
      </div>
    </div>
  )
}

export default Amount
